import React, { useState, useRef } from "react";
import climatologyJSON from "./climatologyJSON.json";
import "./Climatology.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowPointer,
  faChevronLeft,
  faImage,
  faTemperature0,
  faTemperature2,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const host = process.env.REACT_APP_HOST;

const Climatology = ({ climatologyRightValue, toggleClimatologySwitcher }) => {
  const [imageURL, setImageURL] = useState("");
  const [showData, setShowData] = useState(false);
  const [pictureAvailable, setPictureAvailable] = useState(false);
  const climateData = useRef();
  const [showPicture, setShowPicture] = useState(false);
  const climatePicture = useRef();

  //---------------------------------------------This is used to determine if we have the picture that corresponds---------------------------------------//
  /**
   * This function modifies the input to correspond to backend formatting
   * @param {*} input
   * @returns
   */
  const extractVariable = (input) => {
    // Remove parentheses and content inside them
    let result = input.replace(/\([^)]*\)/g, "");
    // Convert to lowercase
    result = result.toLowerCase();
    // Remove any leading or trailing whitespace
    result = result.trim();
    return result;
  };
  //-------------------------------------------------------------------------------------------------------------------------------------------------------//'
  /**
   * This function looks for a pisture in the backend with the name of the site and its climatology measurement
   * @param {*} name
   * @param {*} param
   */
  const getPictures = (name, param) => {
    const paramModified = extractVariable(param);
    console.log("kanei axios");
    axios
      .get(`${host}/getClimatologyPictures/${name}/${paramModified}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        console.log(response);
        const blob = new Blob([response.data], { type: "image/png" });
        setImageURL(URL.createObjectURL(blob));
        setShowPicture(true);
        setPictureAvailable(true);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setPictureAvailable(false);
        setShowPicture(true);
      });
  };

  //name here is the object title aka teh sitename
  /**
   * This function uses the site name to show the div and place the correct picture in it
   * @param {*} name
   * @param {*} index
   */
  const handleClimaClick = (name, index) => {
    console.log("area clicked", name);
    climateData.current = showClimaData(name, index);
    setShowData(true);
  };
  /**
   * This function creates the window for the picture to be and depending if it exists or not sends the appropriate response
   * @param {*} name
   * @param {*} index
   * @returns Divs with site picture
   */
  const showClimaData = (name, index) => {
    const locationData = climatologyJSON.climatology[index];

    if (!locationData) {
      // Handle the case where the location data is not found
      return null;
    }

    function transformKey(key) {
      const pattern = /\$\^\{(.*?)\}\$(.*?)/g;
      const replacements = {
        o: "°",
      };
      return key.replace(pattern, (match, unit, measure) => {
        return (
          (replacements[unit] || unit) + (replacements[measure] || measure)
        );
      });
    }

    return (
      <div key={index} className="clima-data">
        <div className="clima-close-button" onClick={() => setShowData(false)}>
          <FontAwesomeIcon icon={faChevronLeft} /> Back
        </div>
        <div className="clima-header">
          <h2>{name}</h2>
        </div>
        <div className="data-text">
          {Object.entries(locationData[name]).map(
            ([param, data], dataIndex) => (
              <div key={dataIndex} className="clima-data-values">
                <div className="picture-icon">
                  <FontAwesomeIcon
                    icon={faImage}
                    onClick={() => getPictures(name, param)}
                  />
                </div>
                <div>{transformKey(param)}:</div>
                <div
                  style={{ fontWeight: data.significant ? "bold" : "normal" }}
                >
                  {data.value}
                </div>
              </div>
            )
          )}
        </div>
      </div>
    );
  };

  //Make all teh buttons
  const locationButtons = climatologyJSON.climatology.map((location, index) => (
    //surround them in divs so the display flex works
    <div className="climatology-button" id="climatology-button">
      <div
        className={`inside-text`}
        onClick={() => handleClimaClick(Object.keys(location)[0], index)}
      >
        {Object.keys(location)[0]}
      </div>
    </div>
  ));

  return (
    <>
      <div
        className="climatology-container"
        id="climatology-container"
        style={{
          width: showData ? "400px" : "200px",
          right: `${climatologyRightValue}`,
        }}
      >
        <div className="climatology-nav">
          <div className="feature-info-nav-icon">
            <FontAwesomeIcon icon={faTemperature2} />
          </div>
          <div className="feature-info-nav-title">Climatology</div>
          <button
            className="feature-info-tab-close-btn"
            onClick={() => toggleClimatologySwitcher()}
          >
            ×
          </button>
        </div>
        {!showData ? (
          <div className="climatology">{locationButtons}</div>
        ) : (
          climateData.current
        )}
      </div>
      {showPicture && (
        // <div className="picture-view-container">
        <div className="clima-picture-container">
          <div
            className="picture-close-button"
            onClick={() => setShowPicture(false)}
          >
            ✖
          </div>
          {pictureAvailable ? (
            <div className="picture">
              <img src={imageURL} alt="picture" className="clima-picture" />
            </div>
          ) : (
            <div className="no-picture-container">
              <div className="clima-no-picture-image-container">
                <img
                  className="clima-no-picture-image"
                  src={require("../loginPictures/Triquetra-logo-300x285.png")}
                  alt="login-logo"
                />
              </div>
              <div className="clima-no-picture">No chart available</div>
            </div>
          )}
        </div>
        // </div>
      )}
    </>
  );
};

export default Climatology;
